module.exports = __webpack_public_path__ + "img/conny-f-stage1.9a6ca42f.png";